const REPEAT = {
    REPEAT_NO: 1, // '1'=>'Does not repeat',
    REPEAT_EVERYDAY: 2, // '2'=>'Every day (Monday - Sunday)',
    REPEAT_EVERY_WEEKDAY: 3, // '3'=>'Every weekday (Monday - Friday)',
    REPEAT_EVERY_WEEKEND: 4, // '4'=>'Every weekend (Saturday - Sunday)',
    REPEAT_EVERY_MWFDAY: 5, // '5'=>'Every Monday, Wednesday, Friday',
    REPEAT_EVERY_TTDAY: 6, // '6'=>'Every Tuesday and Thursday',
    REPEAT_EVERY_WEEK: 7, // '7'=>'Every Week',
    REPEAT_EVERY_TWO_WEEKS: 10, // '10'=>'Every 2 Weeks',
    REPEAT_EVERY_MONTH: 8, // '8'=>'Every Month',
    REPEAT_EVERY_YEAR: 9, // '9'=>'Every Year',
    REPEAT_EVERY_THREE_WEEKS: 11, // '11'=>'Every 3 Weeks',
    REPEAT_EVERY_FOUR_WEEKS: 12, // '12'=>'Every 4 Weeks',
    REPEAT_CUSTOM: 13 // '13'=>'Custom'
};

const REPEAT_DESC = {
    1: "Does not repeat",
    2: "Every day (Monday - Sunday)",
    3: "Every weekday (Monday - Friday)",
    4: "Every weekend (Saturday - Sunday)",
    5: "Every Monday, Wednesday, Friday",
    6: "Every Tuesday and Thursday",
    7: "Every Week",
    10: "Every 2 Weeks",
    8: "Every Month",
    9: "Every Year",
    11: "Every 3 Weeks",
    12: "Every 4 Weeks",
    13: "Custom"
};

export default {
    REPEAT,
    REPEAT_DESC
};
